import axios from "axios";
const axiosToken = axios.create({
    //baseURL: 'http://127.0.0.1:8000',
    baseURL: 'https://backend.mafert.com',
});
export default axiosToken;